export class FoodImageModel {
    public FoodImageId:number;
    public Name:string;
    public Path:string;
    public ImageByteData?:any;
}
